import React, { useState } from 'react';
import { ThermometerSnowflake, Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/Button';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const navLinks = [{
    name: 'Benefits',
    href: '#benefits'
  }, {
    name: 'How It Works',
    href: '#how-it-works'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'FAQ',
    href: '#faq'
  }];
  return <header className="sticky top-0 z-50 w-full border-b bg-white/95 backdrop-blur supports-[backdrop-filter]:bg-white/60" data-id="element-182">
      <div className="container mx-auto px-4 md:px-6 h-16 flex items-center justify-between" data-id="element-183">
        {/* Logo */}
        <div className="flex items-center gap-2" data-id="element-184">
          <ThermometerSnowflake className="h-6 w-6 text-primary" data-id="element-185" />
          <span className="text-xl font-bold tracking-tight text-slate-900" data-id="element-186">
            Sunflow
          </span>
        </div>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-187">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-slate-600 hover:text-primary transition-colors" data-id="element-188">
              {link.name}
            </a>)}
        </nav>

        {/* Desktop CTA */}
        <div className="hidden md:flex items-center gap-4" data-id="element-189">
          <a href="tel:647-706-9908" className="flex items-center gap-2 text-sm font-medium text-slate-600 hover:text-primary transition-colors" data-id="element-190">
            <Phone className="h-4 w-4" data-id="element-191" />
            (647) 706-9908
          </a>
          <Button onClick={() => document.getElementById('quote-form')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-192">
            Get Quote
          </Button>
        </div>

        {/* Mobile Menu Button */}
        <button className="md:hidden p-2 text-slate-600" onClick={toggleMenu} aria-label="Toggle menu" data-id="element-193">
          {isMenuOpen ? <X className="h-6 w-6" data-id="element-194" /> : <Menu className="h-6 w-6" data-id="element-195" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && <div className="md:hidden border-t bg-white p-4 space-y-4 animate-in slide-in-from-top-5" data-id="element-196">
          <nav className="flex flex-col gap-4" data-id="element-197">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-base font-medium text-slate-600 hover:text-primary" onClick={() => setIsMenuOpen(false)} data-id="element-198">
                {link.name}
              </a>)}
            <hr className="border-slate-100" data-id="element-199" />
            <a href="tel:647-706-9908" className="flex items-center gap-2 text-base font-medium text-slate-600" data-id="element-200">
              <Phone className="h-4 w-4" data-id="element-201" />
              (647) 706-9908
            </a>
            <Button fullWidth onClick={() => {
          setIsMenuOpen(false);
          document.getElementById('quote-form')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} data-id="element-202">
              Get Quote
            </Button>
          </nav>
        </div>}
    </header>;
}